import { Input, OnInit, Component, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';

import { CheckboxGroup } from './models';

@Component({
  selector: 'tablesready-checkbox-group',
  templateUrl: './checkbox-group.component.html',
  styleUrls: ['./checkbox-group.component.scss'],
})
export class CheckboxGroupComponent implements OnInit, ControlValueAccessor {
  @Input() items: CheckboxGroup[];
  @Input() selectAll = false;
  @Input() selectAllTitle = 'All items';
  @Input() searchTitle = 'Search items';
  @Input() searchPlaceholder = 'Search items';
  @Input() contentStyle: Record<string, unknown> = {};
  @Input() displaySearch = true;

  onChange: (value: string[]) => void;
  onTouched: () => void;
  disabled = false;
  selectedItems: string[];
  itemsToDisplay: CheckboxGroup[];

  constructor(@Self() public control: NgControl) {
    control.valueAccessor = this;
  }

  ngOnInit(): void {
    this.itemsToDisplay = this.items;
  }

  toggleAll(checked: boolean) {
    this.selectedItems = checked ? this.items.map(({value}) => value) : [];
    if (this.onChange) {
      this.onChange(this.selectedItems);
    }
    if (this.onTouched) {
      this.onTouched();
    }
  }

  itemSelected(value: string): boolean {
    return this.selectedItems.includes(value);
  }

  registerOnChange(fn: () => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(value: string[]): void {
    this.selectedItems = value;
  }

  change(checked: boolean, value: string) {
    if (checked) {
      this.selectedItems.push(value);
    } else {
      this.selectedItems = this.selectedItems.filter(item => item !== value);
    }
    if (this.onChange) {
      this.onChange(this.selectedItems);
    }
    if (this.onTouched) {
      this.onTouched();
    }
  }

  filterItems(queryString: string): void {
    this.itemsToDisplay = this.items.filter(item => item.name.toLowerCase().includes(queryString));
  }

  get showSelectAll(): boolean {
    return this.items.length === this.itemsToDisplay.length;
  }

  get allItemsSelected(): boolean {
    return this.items.length <= this.selectedItems.length;
  }
}
